import { render, staticRenderFns } from "./Select-Customer-Person.vue?vue&type=template&id=47abe1ec&scoped=true&"
import script from "./Select-Customer-Person.vue?vue&type=script&lang=js&"
export * from "./Select-Customer-Person.vue?vue&type=script&lang=js&"
import style0 from "./Select-Customer-Person.vue?vue&type=style&index=0&id=47abe1ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47abe1ec",
  null
  
)

export default component.exports